import React from 'react'
import dayjs from 'dayjs'
import { isEqual } from 'libraries/lodash'
import cx from 'classnames'
import Icon from 'components/shared/Icon'
import { DATE_FORMAT } from 'constants/locale'

const FilterOption = ({ aol, label, props, compare, getUrl }) => (
  <a
    href={getUrl(compare)}
    className='db mt2 f5 black no-underline ca-filter-link hover-no-underline w-max-content'
    data-event-category='Current Awareness'
    data-event-action='Filter'
    data-event-label={label}
    data-event-aol={aol}
  >
    <div className='flex items-center'>
      <Icon
        className={cx('w6 mr4', { 'dark-cerulean': isEqual(props, compare) })}
        name={isEqual(props, compare) ? 'icon-radiobox-marked' : 'icon-radiobox-blank'}
      />
      <span className='black'>{label}</span>
    </div>
  </a>
)

const QuickDatePicker = ({ fromDate, toDate, getUrl, aol }) => (
  <div className='mb4 pv3' data-help-item='caquicklinks' data-help-position='middle'>
    <h4 className='mv1 f5 fw6 black lh-copy'>Show features from:</h4>
    <FilterOption
      aol={aol}
      label='This week'
      getUrl={getUrl}
      props={{ fromDate, toDate, aol }}
      compare={{
        fromDate: dayjs().subtract(1, 'day').startOf('week').add(1, 'day').format(DATE_FORMAT),
        toDate: dayjs().format(DATE_FORMAT),
        aol
      }}
    />
    <FilterOption
      aol={aol}
      label='Last week'
      getUrl={getUrl}
      props={{ fromDate, toDate, aol }}
      compare={{
        fromDate: dayjs().startOf('week').subtract(1, 'week').add(1, 'day').format(DATE_FORMAT),
        toDate: dayjs().startOf('week').format(DATE_FORMAT),
        aol
      }}
    />
    <FilterOption
      aol={aol}
      label='This month'
      getUrl={getUrl}
      props={{ fromDate, toDate, aol }}
      compare={{
        fromDate: dayjs().startOf('month').format(DATE_FORMAT),
        toDate: dayjs().format(DATE_FORMAT),
        aol
      }}
    />
    <FilterOption
      aol={aol}
      label='Last month'
      getUrl={getUrl}
      props={{ fromDate, toDate, aol }}
      compare={{
        fromDate: dayjs().startOf('month').subtract(1, 'month').format(DATE_FORMAT),
        toDate: dayjs().startOf('month').subtract(1, 'day').format(DATE_FORMAT),
        aol
      }}
    />
  </div>
)

export default QuickDatePicker
